<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/hrxw3p/images/9780316040693.jpg?1734367810106" alt="This image is the cover for the book Death's Shadow, The Demonata"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Death's Shadow, The Demonata
      </h1>
      <p class="bookDescription body article font2">
        <p><b>An ancient warrior returns to face a post-apocalyptic enemy in the 7th installment of this YA horror series.</b></p><p>The apocalypse came and the world burned. But it wasn't the end, and out of the destruction, new life has emerged. Bec is back to face the Demonata. After centuries of imprisonment, she's more powerful than ever, but the demons no longer stand alone. Something has crawled out of the darkness with her. Lord Loss is no longer humanity's greatest threat...</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Darren Shan
      </h2>
      
      <p class="authorDescription body article"><B>Darren Shan</B> is the bestselling author of the young adult series Cirque Du Freak, The Demonata, and the Saga of Larten Crepsley series, as well as the stand-alone book <I>The Thin Executioner</I>. His books have sold over 25 million copies worldwide. Shan divides his time between his homes in Ireland and London.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Little, Brown and Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?37db1eb2